<div class="odp-performance-wrapper">
  <!-- Informational Text Section -->
  <div class="row">
    <div class="col-12">
      <div class="info-text-container mt-3">
        <h3 class="info-heading">PBC Data Center</h3>

        <p class="info-text">
          In order to assist providers in understanding their PBC results and determining whether to engage the Resolution Process, we have created the following dashboard with two tables of information. The table on the right is a scoring rubric that displays the thresholds for data-based PBC measures. The table on the left lists <strong>your agency's performance</strong> on those measures based on data gathered by ODP and submitted by your agency. There is a caret to the left of each performance area that will expand or collapse each section. To the right of each performance area are colored ovals that indicate whether your agency's data results in a "Met" or an "Unmet" value based on the tier you submitted for, which is listed on the top right side of the performance measure table.
        </p>

        <p class="info-text">
          <strong>To initiate the Resolution Process, select the "Flag" icon under "Actions" on the right-hand side of the list above.</strong> Please note that only providers that submitted for the Select and Clinically Enhanced tiers are eligible to engage the Resolution Process.
        </p>

        <p class="info-text">
          In addition, some of the below measures are part of composite scoring categories; if you would like additional information about these measures, please
          <a
            href="https://home.myodp.org/resources/waiver-implementation/pbc-residential-services/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <u>review the Process Details spreadsheet</u>
          </a>.
        </p>
      </div>
    </div>
  </div>

  <!-- Performance Measures Component -->
  <div class="odp-content-wrapper">
    <div class="performance-section">
      <div
        class="mt-3 ttlborder"
        *ngIf="performanceAreas && performanceAreas.length > 0"
      >
        <div
          class="w-100 overflow-x"
          aria-describedby="PerformanceMeasuresTable"
        >
          <table
            mat-table
            id="PerformanceMeasuresTable"
            [dataSource]="dataSource"
            class="tblscroll"
          >
            <ng-container matColumnDef="header-row-performance">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="borderRad"
              >
                <div
                  class="mat-subheading-1 heading-color header-container"
                >
                  <p
                    class="header-mat-panel-title mat-subheading-1"
                  >
                    ODP Monitored Performance Measures
                  </p>

                  <span
                    class="header-badge"
                    *ngIf="selectedTierCode"
                    [ngClass]="getTierBadgeClass(selectedTierCode)"
                  >
                    {{ getTierLabel(selectedTierCode) }} Tier
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container matColumnDef="content">
              <td
                mat-cell
                *matCellDef="let _"
              >
                <div class="performance-data">
                  <div
                    *ngFor="
                      let area of performanceAreas;
                      let areaIndex = index
                    "
                    class="performance-area"
                  >
                    <div
                      class="expandable-row level-1"
                      (click)="toggleArea(areaIndex)"
                    >
                      <div class="row-content">
                        <div class="row-left">
                          <span
                            class="expand-arrow"
                            [class.expanded]="area.expanded"
                          ></span>

                          <span class="row-title">
                            {{ area.performanceAreaTitle }}:
                            {{ area.performanceAreaDescription }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      class="nested-content level-2"
                      [class.expanded]="area.expanded"
                    >
                      <div
                        *ngFor="
                          let measure of area.measures;
                          let measureIndex = index;
                          trackBy: trackMeasure
                        "
                        class="measure-row"
                      >
                        <div
                          class="expandable-row individual-measure"
                          [class.expanded]="measure.expanded"
                          role="button"
                          tabindex="0"
                          [attr.aria-expanded]="measure.expanded"
                          (click)="toggleMeasure(areaIndex, measureIndex)"
                          (keydown.enter)="toggleMeasure(areaIndex, measureIndex)"
                          (keydown.space)="toggleMeasure(areaIndex, measureIndex)"
                        >
                          <div class="row-content">
                            <div class="row-left">
                              <span
                                class="expand-arrow"
                                [class.expanded]="measure.expanded"
                              ></span>

                              <div class="measure-content">
                                <span class="measure-title">
                                  <span class="measure-label">
                                    Measure {{ measure.measureTitle }}:
                                  </span>

                                  <span class="measure-desc-text">
                                    {{ measure.measureDescription }}
                                  </span>
                                </span>
                              </div>
                            </div>

                            <div class="row-badges">
                              <span
                                class="status-badge"
                                *ngIf="
                                  measure?.isMeasureMet !== undefined &&
                                  measure?.isMeasureMet !== null
                                "
                                [class.badge-met]="measure.isMeasureMet"
                                [class.badge-unmet]="!measure.isMeasureMet"
                              >
                                {{
                                  measure.isMeasureMet
                                    ? 'Met'
                                    : 'Unmet'
                                }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div
                          class="nested-content level-3"
                          [class.expanded]="measure.expanded"
                          *ngIf="
                            measure.outcomes &&
                            measure.outcomes.length > 0
                          "
                        >
                          <div class="outcomes-block">
                            <div class="outcomes-list">
                              <div
                                class="outcome-row"
                                *ngFor="let outcome of measure.outcomes"
                              >
                                <div class="outcome-desc">
                                  <span
                                    class="outcome-desc"
                                    [innerHtml]="outcome.outcomeDescription"
                                  ></span>

                                  <span
                                    class="outcome-inline-percentage"
                                  >
                                    {{ outcome.outcomePercentage }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr
              mat-header-row
              class="tableHeading"
              *matHeaderRowDef="
                ['header-row-performance'];
                sticky: true
              "
            ></tr>

            <tr
              mat-row
              *matRowDef="
                let element;
                columns: ['content']
              "
              class="example-element-row"
            ></tr>
          </table>
        </div>
      </div>

      <div
        class="row mt-3 mx-2 ttlborder"
        *ngIf="
          performanceAreas &&
          performanceAreas.length === 0
        "
      >
        <div class="no-data-msg w-100 p-3">
          No performance measures available.
        </div>
      </div>
    </div>

    <!-- Right Section: Tier Measure Requirements Table -->
    <div
      class="col-md-5 right-section"
      style="flex: 0 0 40%; max-width: 40%;"
    >
      <div class="mt-3 ttlborder">
        <div class="requirements-header">
          <h3 class="requirements-title">
            Measure Threshold Values
          </h3>
        </div>

        <div class="w-100">
          <table
            class="table table-bordered requirements-table"
          >
            <thead>
              <tr>
                <th class="measure-code-header">
                  Measure Code
                </th>

                <th
                  *ngFor="let tier of visibleTiers"
                  [class]="tier.headerClass"
                  [class.selected-tier-header]="
                    normalizeTierCode(selectedTierCode) ===
                    tier.code
                  "
                >
                  {{ tier.label }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                *ngFor="
                  let requirement of requirementsData
                "
              >
                <td class="measure-code-cell">
                  {{ requirement.measureCode }}
                </td>

                <td
                  *ngFor="let tier of visibleTiers"
                  class="value-cell"
                  [class]="tier.cellClass"
                  [class.selected-tier-cell]="
                    normalizeTierCode(selectedTierCode) ===
                    tier.code
                  "
                >
                  {{ requirement[tier.field] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>